import React from "react";
import { formatRange } from "../../pages/vacationDates";

const KIND_LABELS = { vacation: "Отпуск", unpaid: "Отгул" };
const MS_PER_DAY = 86400000;

function utcDay(iso) {
  const [year, month, day] = iso.split("-").map(Number);
  return Date.UTC(year, month - 1, day);
}

export function daysInclusive(start, end) {
  return Math.round((utcDay(end) - utcDay(start)) / MS_PER_DAY) + 1;
}

export default function AbsenceTile({ absence, selected, state, onSelect }) {
  const kind = KIND_LABELS[absence.kind] || absence.kind;
  const dates = formatRange(absence.start_date, absence.end_date);
  const days = daysInclusive(absence.start_date, absence.end_date);
  return (
    <button
      type="button"
      className={`vs-tile vs-tile--${state}${selected ? " vs-tile--selected" : ""}`}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <span className="vs-tile__kind">{kind}</span>
      <span className="vs-tile__dates vs-mono">{dates}</span>
      <span className="vs-tile__days">{days} дн</span>
    </button>
  );
}
